import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';

import {AppComponent} from './app.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {RecipeEditComponent} from './recipe/edit/recipe-edit/recipe-edit.component';
import {AngularFireModule} from "@angular/fire/compat";

import {environment} from "../environments/environment";
import {AngularFireAuthModule} from "@angular/fire/compat/auth";
import {AngularFirestoreModule} from "@angular/fire/compat/firestore";
import {AngularFireStorageModule} from "@angular/fire/compat/storage";
import {AppRoutingModule} from './app-routing.module';
import {RecipeListComponent} from './recipe/recipe-list/recipe-list.component';
import {HomeComponent} from './home/home.component';
import {RecipePartEditComponent} from './recipe/edit/recipe-part-edit/recipe-part-edit.component';
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {LoginComponent} from './login/login.component';
import {RegisterComponent} from './register/register.component';
import {AdminComponent} from './admin/admin.component';
import {AngularFireFunctionsModule, REGION} from "@angular/fire/compat/functions";
import {UserVerificationComponent} from './user-verification/user-verification.component';
import {SingleFileUploadComponent} from './single-file-upload/single-file-upload.component';
import {ProfileComponent} from './profile/profile.component';
import {BlockedComponent} from './blocked/blocked.component';
import {RecipeCardComponent} from './recipe/recipe-card/recipe-card.component';
import {RecipeViewComponent} from './recipe/view/recipe-view/recipe-view.component';
import {RecipePartViewComponent} from './recipe/view/recipe-part-view/recipe-part-view.component';
import {RecipeImageComponent} from './recipe/view/recipe-image/recipe-image.component';
import {LightboxModule} from "ngx-lightbox";
import {MomentjsPipe} from "./pipes/momentjs.pipe";
import {NgbModalModule, NgbTooltipModule} from "@ng-bootstrap/ng-bootstrap";
import {NgxDropzoneModule} from "ngx-dropzone";
import {ToastrModule} from "ngx-toastr";

@NgModule({
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireAuthModule,
    AngularFireFunctionsModule,
    AngularFirestoreModule,
    AngularFireStorageModule,
    FormsModule,
    NgbModalModule,
    NgbTooltipModule,
    NgxDropzoneModule,
    AppRoutingModule,
    ReactiveFormsModule,
    LightboxModule,
    ToastrModule.forRoot({
      positionClass: 'toast-bottom-right',
    })
  ],
  declarations: [
    AppComponent,
    RecipeEditComponent,
    RecipeListComponent,
    HomeComponent,
    RecipePartEditComponent,
    LoginComponent,
    RegisterComponent,
    AdminComponent,
    UserVerificationComponent,
    SingleFileUploadComponent,
    ProfileComponent,
    BlockedComponent,
    RecipeCardComponent,
    RecipeViewComponent,
    RecipePartViewComponent,
    RecipeImageComponent,
    MomentjsPipe
  ],
  bootstrap: [AppComponent],
  providers: [
    {provide: REGION, useValue: 'europe-west1'}
  ]
})
export class AppModule {
}
